import {
  AgentCloudTestCreationType,
  AgentTestOperation,
} from '@elementary/common-ui/types';
import { ColumnSchema, ConfigFieldKey } from './types';

export const SENSITIVITY_OPTIONS = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
];

export const ANOMALY_DIRECTION_OPTIONS = [
  { value: 'BOTH', label: 'Both' },
  { value: 'SPIKE', label: 'Spike' },
  { value: 'DROP', label: 'Drop' },
];

export const SEVERITY_OPTIONS = [
  { value: 'WARNING', label: 'Warning' },
  { value: 'ERROR', label: 'Error' },
];

export const TEST_TYPE_FIELDS: Record<
  AgentCloudTestCreationType,
  ConfigFieldKey[]
> = {
  freshness: [
    'sensitivity',
    'threshold',
    'trainingPeriod',
    'severity',
    'owners',
    'tags',
  ],
  volume: [
    'sensitivity',
    'anomalyDirection',
    'detectionPeriod',
    'trainingPeriod',
    'severity',
    'owners',
    'tags',
  ],
};

export const TEST_TYPE_NAMES: Record<AgentCloudTestCreationType, string> = {
  freshness: 'freshness_anomalies',
  volume: 'volume_anomalies',
};

export const TEST_TYPE_SUB_TYPES: Record<AgentCloudTestCreationType, string> = {
  freshness: 'freshness',
  volume: 'content',
};

export const BREADCRUMB_LABELS: Record<AgentTestOperation, string> = {
  update: 'Changes Preview',
  create: 'Creation Preview',
  delete: 'Deletion Preview',
};

export const COLUMN_SCHEMA: ColumnSchema[] = [
  {
    type: 'dropdown',
    key: 'sensitivity',
    id: 'sensitivity_change',
    header: 'Sensitivity',
    options: SENSITIVITY_OPTIONS,
  },
  {
    type: 'period',
    key: 'threshold',
    id: 'threshold_change',
    header: 'Threshold',
    nullable: true,
  },
  {
    type: 'dropdown',
    key: 'anomalyDirection',
    id: 'anomaly_direction_change',
    header: 'Anomaly direction',
    options: ANOMALY_DIRECTION_OPTIONS,
  },
  {
    type: 'period',
    key: 'detectionPeriod',
    id: 'detection_period_change',
    header: 'Detection period',
  },
  {
    type: 'period',
    key: 'trainingPeriod',
    id: 'training_period_change',
    header: 'Training period',
  },
  {
    type: 'dropdown',
    key: 'severity',
    id: 'severity_change',
    header: 'Severity',
    options: SEVERITY_OPTIONS,
  },
  {
    type: 'list',
    key: 'owners',
    id: 'owners_change',
    header: 'Owners',
    itemLabel: ['owner', 'owners'],
    optionsKey: 'owners',
  },
  {
    type: 'list',
    key: 'tags',
    id: 'tags_change',
    header: 'Tags',
    itemLabel: ['tag', 'tags'],
    optionsKey: 'tags',
  },
  {
    type: 'boolean',
    key: 'enabled',
    id: 'enabled_change',
    header: 'Test enabled',
    trueLabel: 'Enable Test',
    falseLabel: 'Disable Test',
  },
  {
    type: 'boolean',
    key: 'muted',
    id: 'muted_change',
    header: 'Alerts muted',
    trueLabel: 'Mute Alerts',
    falseLabel: 'Unmute Alerts',
  },
];

export const STORAGE_KEY = 'agent_config_preview_table';
